import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./LeadsPage.css";

function LeadsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [selectedSource, setSelectedSource] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCampaignDetails = async () => {
      try {
        const Authtoken = localStorage.getItem("token");
        const response = await axios.get("https://leadbankapi.gensparc.com/api/facebook/campaign", {
          headers: { Authorization: `Bearer ${Authtoken}` },
        });

        if (Array.isArray(response.data)) {
          setCampaigns(response.data);
        } else {
          setCampaigns([response.data]);
        }
      } catch (error) {
        console.error("Error fetching campaign details:", error);
      }
    };

    fetchCampaignDetails();
  }, []);

  const handleSourceChange = (e) => {
    const selected = e.target.value;
    setSelectedSource(selected);

    if (selected === "Facebook") {
      navigate("/leads");
    } else if (selected === "Web Form") {
      navigate("/home");
    }
  };

  return (
    <div className="campaign-container">
      <div className="source">
        <select id="source-select" className="source-dropdown" value={selectedSource} onChange={handleSourceChange}>

          <option value="Facebook">Facebook</option>
          <option value="Web Form">Web Form</option>
        </select>
      </div>

      <h1>Campaign Details</h1>

      <table className="campaign-table">
        <thead>
          <tr>
            <th>Campaign Name</th>
            <th>Page</th>
            <th>Form</th>
            <th>Integrate</th>
            <th>Report</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((campaign, index) => (
            <tr key={index}>
              <td
               
              >
                {campaign.name}
              </td>
              <td
                // onClick={() => navigate(`/campaign/${campaign.id}`)}
                // className="clickable-row"
              >
                {campaign.pageName}
              </td>
              <td
                // onClick={() => navigate(`/campaign/${campaign.id}`)}
                // className="clickable-row"
              >
                {campaign.formName}
              </td>
              <td>
                <button
                  className="integration-button"
                  onClick={() => navigate(`/facebookdialer/${campaign.formId}`)}
                >
                  ⚙️
                </button>
              </td>
              <td>
                <button
                  className="integration-button"
                  onClick={() => navigate(`/dialer-logs/${campaign.formId}`)}
                >
                  📜
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LeadsPage;
